import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const CoverTemplatesContainer = styled.div`
  min-height: 100%;

  .ctrl-row {
    @media (max-width: ${breakpoints.xs}px) {
      flex-direction: row-reverse;
      flex-wrap: wrap-reverse;

      .template-btn {
        margin: auto;
        width: 75%;
      }
    }

    @media (max-width: ${breakpoints.sm}px) {
      .switch-label {
        font-size: 14px;
      }

      .template-btn {
        padding: 0 10px 0 7px;
      }
    }
  }
  .cover-template-subtitle {
    margin-bottom: 2rem;
  }

  .ant-switch-checked {
    background-color: ${colors.blueDark};
  }

  .template-btn {
    padding-left: 14px;
    height: 32px;
    margin-left: auto;

    span {
      vertical-align: middle;
    }
  }

  .template-item {
    border: 1px solid ${colors.border};
    border-radius: 10px;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    cursor: pointer;

    &:hover {
      box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
        0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
    }

    .template-title {
      padding: 16px 24px 0px 24px;
      margin-bottom: 0;
    }

    .template-icon {
      margin: 24px;
      border: 1px solid black;
      width: 145px;
      height: 100px;
    }

    &.create-own {
      border: 2px solid ${colors.dark7};

      .create-own-icon {
        color: ${colors.blueDark};
        margin: 16px 24px;
      }
    }
  }
`
